module.exports = __webpack_public_path__ + "assets/img/sanjay-patel-1.c86ed5e9.jpg";